module.exports = __webpack_public_path__ + "static/img/bg1.efebaa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg1.png
// module id = yfdd
// module chunks = 1